import english from "./english";
import portuguese from "./portuguese";
import french from "./french";
import spanish from "./spanish";
import italian from "./italian";
import irish from "./irish";
import german from "./german";
import chinese from "./chinese";
import japanese from "./japanese";

const exportObject = {
  english,
  portuguese,
  french,
  spanish,
  italian,
  irish,
  german,
  chinese,
  japanese,
};

export default exportObject;
